/**
 * SOLID Review
 * S — Strong. One concern: a video tile's volume slider — its own value, handed on to whoever listens.
 * O — Good. Any tile.
 * L — Strong. A view model (`IServiceViewModel`).
 * I — Strong. The volume and its setter.
 * D — Strong. Imports only the view-model contract and its state.
 */
import type { IServiceViewModel } from './IServiceViewModel';
import { ObservableState } from './ObservableState';

export interface IStateTileVolume {
  readonly volume: number;
}

const FULL: IStateTileVolume = { volume: 1.0 };

/** A VIDEO TILE'S VOLUME (frontend-framework-oo P5, 2026-10-30, §28.297) — `components/layout/topSection/VideoTile.tsx`'s state. */
export class TileVolumeModel implements IServiceViewModel<IStateTileVolume> {
  private readonly state = new ObservableState<IStateTileVolume>(FULL);

  /** The slider moved: the tile's own value, and the listener its view hands it. */
  readonly setVolume = (volume: number, onVolumeChange?: (volume: number) => void): void => {
    const moved: Partial<IStateTileVolume> = { volume };
    this.state.update(moved);
    onVolumeChange?.(volume);
  };

  getSnapshot(): IStateTileVolume {
    return this.state.get();
  }

  subscribe(listener: () => void): () => void {
    return this.state.subscribe(listener);
  }

  attach(): void {}

  detach(): void {}
}
